<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <BreadCrumbs v-model="currentGroupId" @click_breadCrumbs="selectedGroupChange" />
      </v-col>
    </v-row>
    <v-row class="my-0">
      <v-col>
        <v-card outlined>
          <v-card-text>
            <v-row class="">
              <v-col cols="2">
                <v-card outlined class="mb-3">
                  <v-list color="#E5EEF7">
                    <v-list-item class="mb-3">
                      <v-row>
                        <v-col>
                          <v-img
                            :src="require('@/assets/oil_injection.png')"
                            :height="apexWidthHeight"
                            :width="apexWidthHeight"
                            contain
                          >
                          </v-img>
                        </v-col>
                        <v-col>
                          <div class="text-h2 text-end">{{ devicesCount | numberFormat }}</div>
                          <div class="text-h6">{{ $t('numberOfMachines') }}</div>
                        </v-col>
                      </v-row>
                    </v-list-item>
                    <v-list-item class="mt-5">
                      <v-row>
                        <v-col>
                          <v-row>
                            <v-col cols="6" class="text-end"
                              ><v-icon :size="apexWidthHeight * 0.5">mdi-signal</v-icon>
                            </v-col>
                            <v-col class="text-h4 text-end">
                              {{ communicatedCount | numberFormat }}
                            </v-col>
                          </v-row>
                          <v-row class="ma-0 pa-0">
                            <v-col class="text-h6 text-end ma-0 pa-0">
                              {{ $t('communicated') }}
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-list-item>
                    <v-list-item class="mt-5">
                      <v-row>
                        <v-col>
                          <v-row>
                            <v-col cols="6" class="text-end">
                              <v-icon :size="apexWidthHeight * 0.5">mdi-signal-off</v-icon>
                            </v-col>
                            <v-col class="text-h4 text-end">
                              {{ connectionOffCount | numberFormat }}
                            </v-col>
                          </v-row>
                          <v-row class="ma-0 pa-0">
                            <v-col class="text-h6 text-end ma-0 pa-0">
                              {{ $t('disconnected') }}
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-list-item>
                  </v-list>
                </v-card>
                <v-card outlined>
                  <v-list color="#E5EEF7">
                    <div v-for="(item, index) in pieData" v-bind:key="index" class="mb-2">
                      <v-list-item>
                        <v-row>
                          <v-col>
                            <v-progress-circular v-if="loading" indeterminate></v-progress-circular>
                            <apexchart
                              type="pie"
                              :width="apexWidthHeight"
                              :height="apexWidthHeight"
                              :options="{ ...apexOptions, ...{ colors: [item.color, 'lightgray'] } }"
                              :series="[item.value, devicesCount - item.value]"
                              v-else
                            />
                          </v-col>
                          <v-col>
                            <div class="text-h2 text-end">{{ item.value | numberFormat }}</div>
                          </v-col>
                        </v-row>
                      </v-list-item>
                      <v-list-item>
                        <v-row>
                          <v-col cols="4"> </v-col>
                          <v-col>
                            <div class="text-h6">{{ $t(item.label) }}</div>
                          </v-col>
                        </v-row>
                      </v-list-item>
                    </div>
                  </v-list>
                </v-card>
              </v-col>
              <v-col cols="10">
                <v-tabs value="tab-1" v-model="tab">
                  <v-tab href="#tab-1" class="mx-2 rounded-t" @change="tab2Active">
                    {{ $t('alarmRecords') }}
                  </v-tab>
                  <v-tab href="#tab-2" class="mx-2 rounded-t" @change="tab1Active">
                    {{ $t('matrix') }}
                  </v-tab>
                </v-tabs>
                <v-tabs-items v-model="tab">
                  <v-tab-item value="tab-1">
                    <DashboardAdminTab2 v-model="currentGroupId" />
                  </v-tab-item>
                  <v-tab-item value="tab-2">
                    <DashboardAdminTab1 v-model="currentGroupId" :devices="devices" :loading="tab1loading" />
                  </v-tab-item>
                </v-tabs-items>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import DashboardAdminTab1 from '@/views/DashboardAdminTab1.vue';
  import DashboardAdminTab2 from '@/views/DashboardAdminTab2.vue';
  import BreadCrumbs from '@/components/BreadCrumbs.vue';
  import { homeAdminTab1Mixin } from '@/utils/dashbord.js';
  import { mapGetters } from 'vuex';

  export default {
    title() {
      return this.$t(this.$route.meta.title);
    },
    name: 'Table',
    components: {
      DashboardAdminTab1,
      DashboardAdminTab2,
      BreadCrumbs,
    },
    mixins: [homeAdminTab1Mixin('homeAdminTab1Mixin')],
    data: () => ({
      tab: '',
      currentGroupId: undefined,
      homeAdminTab1Mixin_value: undefined,
      timerId: undefined,
      timterKey: undefined,
      // 再取得するまでの時間(2h毎)
      intervalMillisecond: 2 * 60 * 60 * 1000,
      devicesCount: 0,
      alermCountEmergency: 0,
      alermCountCaution: 0,
      alermCountMaintenance: 0,
      communicatedCount: 0,
      connectionOffCount: 0,
      drivingCount: 0,
      apexWidthHeight: 80,
      apexOptions: { dataLabels: { enabled: false }, legend: false, tooltip: { enabled: false } },
      devices: undefined,
      loading: true,
      tab1loading: true,
    }),
    filters: {
      numberFormat: (value) => {
        if (isNaN(value) || value === undefined) {
          return '';
        }
        let formatter = new Intl.NumberFormat('ja-JP');
        return formatter.format(value);
      },
    },
    computed: {
      ...mapGetters('auth', ['user_info']),
      pieData() {
        return [
          { label: `running`, value: this.drivingCount, color: '#8BC34A' },
          { label: `emergency`, value: this.alermCountEmergency, color: 'red' },
          { label: `caution`, value: this.alermCountCaution, color: 'orange' },
          { label: `maintenance`, value: this.alermCountMaintenance, color: 'yellow' },
        ];
      },
      isTab1Active() {
        return this.tab === 'tab-1';
      },
      isTab2Active() {
        return this.tab === 'tab-2';
      },
      localeId() {
        switch (this.$i18n.locale) {
          case 'en':
            return 1;
          case 'ja':
            return 2;
          case 'zh':
            return 3;
        }
        return 2;
      },
      isDashbordPage() {
        return this.timterKey === this.$route.fullPath;
      },
    },
    watch: {
      async homeAdminTab1Mixin_groupAuthritesInit(newValue) {
        // storeの初期化が完了すればデバイスを取得する
        if (newValue) {
          if (this.currentGroupId == null) {
            const groupId = this.$route.params.device_group_id;
            if (groupId) {
              this.currentGroupId = groupId;
              this.homeAdminTab1Mixin_value = this.currentGroupId;
            }
          }
          await this.refreshCount();
        }
      },
    },
    async created() {
      clearTimeout(this.timerId);
      this.timterKey = this.$route.fullPath;
      const groupId = this.$route.params.device_group_id;
      if (groupId) {
        this.currentGroupId = groupId;
        this.homeAdminTab1Mixin_value = this.currentGroupId;
      }

      // storeが初期化済みであればここでトリガー
      if (this.homeAdminTab1Mixin_groupAuthritesInit) {
        await this.refreshCount();
      }
    },
    methods: {
      async selectedGroupChange(group) {
        console.log('グループ変更');
        this.currentGroupId = group.device_group_id;
        this.homeAdminTab1Mixin_value = this.currentGroupId;
        // グループIDが変わるので表示もリセット
        this.devicesCount = 0;
        this.alermCountEmergency = 0;
        this.alermCountCaution = 0;
        this.alermCountMaintenance = 0;
        this.communicatedCount = 0;
        this.drivingCount = 0;
        this.connectionOffCount = 0;

        await this.refreshCount();
      },
      tab1Active() {},
      tab2Active() {},
      async refreshCount() {
        this.loading = true;
        this.tab1loading = true;
        try {
          const isContinue = () => {
            return this.isDashbordPage;
          };
          await this.homeAdminTab1Mixin_getGroup(true, false, false, isContinue);

          this.devices = this.homeAdminTab1Mixin_devices;
          this.devicesCount = this.homeAdminTab1Mixin_sum.devicesCount;

          // トップページとは違い、アラームも取得する
          await this.homeAdminTab1Mixin_getGroup(false, true, true, isContinue);

          this.alermCountEmergency = this.homeAdminTab1Mixin_sum?.alermCountEmergency;
          this.alermCountCaution = this.homeAdminTab1Mixin_sum?.alermCountCaution;
          this.alermCountMaintenance = this.homeAdminTab1Mixin_sum?.alermCountMaintenance;
          this.communicatedCount = this.homeAdminTab1Mixin_sum?.communicatedCount;
          this.drivingCount = this.homeAdminTab1Mixin_sum?.drivingCount;
          this.connectionOffCount = this.homeAdminTab1Mixin_sum?.connectionOffCount;

          clearTimeout(this.timerId);
          // 同じ画面の場合のみタイマーをセット
          if (this.isDashbordPage) {
            this.timerId = setTimeout(this.timerFunction, this.intervalMillisecond);
          }
        } finally {
          this.loading = false;
        }
        try {
          this.tab1loading = true;
          await this.getAddionalInfo();
        } finally {
          this.tab1loading = false;
        }
      },
      async timerFunction() {
        const isContinue = () => {
          return this.isDashbordPage;
        };
        if (!this.isDashbordPage) {
          return;
        }
        if (this.homeAdminTab1Mixin_groupAuthritesInit) {
          await this.homeAdminTab1Mixin_getGroup(true, true, true, isContinue);
          this.refreshCount();
        }
      },
      // tab1用追加データ
      getRunningHour(runningHours, device) {
        // //最新のセンサーデータを取得
        const latestSensorData = runningHours.find((el) => {
          return el.modelId === device.model_id && el.serialNo === device.serial_no;
        });

        if (latestSensorData == null) {
          return;
        }
        const list = latestSensorData.timeList.filter(
          (list) => list.dataList.length > 0 && list.sensorId === 'sn_D020_021'
        );
        return list[0]?.dataList[0].data;
      },
      _util_split(array, number) {
        const length = Math.ceil(array.length / number);
        return new Array(length).fill().map((_, i) => array.slice(i * number, (i + 1) * number));
      },
      async getRunningHours(devices) {
        // 運転データ関連
        // 1回で運転データを取得する数 多すぎるとエラーになるので分割して取得
        const DIVID_COUNT = 5;
        const sensors = await devices.map((el) => {
          return {
            model_id: el.model_id,
            serial_no: el.serial_no,
            sensorId: 'sn_D020_021',
          };
        });

        // 分割して取得
        const splited = this._util_split(sensors, DIVID_COUNT);
        let apiResult = [];
        for (const tmp of splited) {
          if (!this.isDashbordPage) {
            return;
          }
          const params = {
            sensor_list: tmp,
          };
          // センサーデータを取得
          const res = await this.apiRequest('/v1/sensor-data-file-mgt/getLatestSensorData', 'POST', params);
          if (res) {
            apiResult = apiResult.concat(res);
          }
        }
        return apiResult;
      },
      async getAnnualInspectionEvent(device) {
        // モデルごとに年次点検が設定されているアドレスとビットが違うので場合分け
        let address = -1;
        let bits = [];
        switch (device.model_id) {
          case 'OIL_INJECTION':
          case 'OIL_INJECTION2':
            address = 28;
            bits = [7];
            break;
          case 'OIL_INJECTION3':
            address = 28;
            bits = [10];
            break;
          case 'OIL_FREE':
          case 'OIL_INJECTION5':
          case 'WATER_INJECTION':
            address = 28;
            bits = [15];
            break;
          case 'OIL_INJECTION4':
            address = 29;
            //bits = [0, 1, 2, 3]; // OH不要
            bits = [0, 1, 2];
            break;
          case 'OIL_INJECTION6':
          case 'FE_LTE_00':
            // 項目なし
            break;
          case 'OIL_FREE2':
            address = 29;
            bits = [0];
            break;
        }
        if (address === -1) return null; // 該当なし

        for (const bit of bits) {
          // M)年次点検のイベントID
          const addressStr = String(address).padStart(3, '0');
          const bitStr = String(bit).padStart(2, '0');
          const event_id = `D${addressStr}_${bitStr}_set`;

          // eventIncidentHistoryの場合は、event_time_from が必須 QA No26及びMTGから直近1年前分＋バッファ1か月分
          const fromDate = this.$moment()
            .add(-1, 'y')
            .add(-1, 'm')
            .startOf('day')
            .format('YYYY-MM-DD HH:mm:ss.SSSSSSS');

          // 年次点検のレコードを取得
          const annualInspectionEvent = await this.apiRequest('/v1/alarm-event-mgt/eventIncidentHistory', 'GET', {
            get_class: '4', // エッジ側イベント検出
            sort: '-event_time',
            event_level: '1', // メンテナンス
            max_number: 1,
            'event_list[0].event_id': event_id,
            'event_list[0].model_id': device.model_id,
            'event_list[0].serial_no': device.serial_no,
            event_time_from: fromDate, // UTC
          });

          if (annualInspectionEvent) {
            return annualInspectionEvent;
          }
        }

        return null;
      },
      async getMaintenanceNotifications() {
        const userId = this.user_info.userId;
        const maintenanceNotifications = await this.azureRequest('/api/getMaintenanceNotifications', 'GET', {
          userId: userId,
          includeInactive: true,
        });

        return maintenanceNotifications;
      },
      findMaintenanceNotificationStatus(compressor, maintenanceNotifications) {
        if (maintenanceNotifications) {
          const machineUnit = compressor.serial_no.replace(/_.*$/, '');
          const maintenanceNotification = maintenanceNotifications.find((item) => item.equipmentNo === machineUnit);

          return maintenanceNotification;
        }
        return null;
      },
      async getAddionalInfo() {
        if (!this.isDashbordPage) {
          return;
        }
        // ユーザーに紐づくメンテナンス通知情報を取得
        const maintenanceNotifications = await this.getMaintenanceNotifications();
        if (!this.isDashbordPage) {
          return;
        }
        // 一括して取得しないとエラーになる
        const runningHours = await this.getRunningHours(this.devices);
        if (!this.isDashbordPage) {
          return;
        }
        await Promise.all(
          this.devices?.map(async (el) => {
            if (this.isDashbordPage) {
              const maintenanceNotification = this.findMaintenanceNotificationStatus(el, maintenanceNotifications);
              // 通知アイコン
              el.maintenanceIcon = maintenanceNotification?.status ?? null;
              // 経過日数
              el.maintenancePastDay = maintenanceNotification?.elapsedDays ?? undefined;

              // APIから総運転時間を取得
              const runningHour = this.getRunningHour(runningHours, el);
              if (runningHour && maintenanceNotification?.fkadotm) {
                // 前回メンテナンスからの総運転時間
                const tmp = Number(runningHour) - Number(maintenanceNotification?.fkadotm);
                if (tmp > 0) {
                  el.maintenancePastTime = tmp;
                } else {
                  // 運転時間がマイナスになる場合は表示しない
                  el.maintenancePastTime = undefined;
                }
              }

              const annualInspectionEvent = await this.getAnnualInspectionEvent(el);
              // 発生中の場合のみ表示
              if (annualInspectionEvent?.length > 0 && annualInspectionEvent[0].incident_class === '1') {
                el.maintenanceAlarm = this.$dayjs(annualInspectionEvent[0].event_time);
              }
            }

            return el;
          })
        );
      },
    },
  };
</script>
<style scoped>
  /** タブ非活性時 */
  .tabDisabled {
    background-color: rgba(0, 0, 0, 0.12);
    color: rgba(0, 0, 0, 0.26);
  }
</style>
